/**
 * Automatic Keyword Linking System
 * Scans page content and automatically links keywords to relevant pages
 * 
 * Add new keywords to the keywordMappings object below
 * Format: 'keyword': '/target-url'
 */

(function() {
  'use strict';

  // Inject CSS to preserve original text styles
  const style = document.createElement('style');
  style.textContent = `
    .auto-keyword-link {
      color: inherit !important;
      text-decoration: underline !important;
      text-underline-offset: 3px !important;
      text-decoration-thickness: 1px !important;
    }
    .auto-keyword-link:hover {
      text-decoration: none !important;
    }
  `;
  document.head.appendChild(style);

  const keywordMappings = {
    // Menstruation products (main collection)
    'wasbaar maandverband': '/collections/maandverband',
    'handgemaakt maandverband': '/collections/maandverband',
    'herbruikbaar maandverband': '/collections/maandverband',
    'uitwasbaar maandverband': '/collections/maandverband',
    'maandverband': '/collections/maandverband',
    'menstruatiepad': '/collections/maandverband',
    'menstruatiepads': '/collections/maandverband',
    'menstruatie producten': '/collections/maandverband',
    'menstruatiespullen': '/collections/maandverband',
    
    // Generic menstruatie - redirect to most popular
    'menstruatie': '/collections/meest-gekocht',
    'menstruatieproducten': '/collections/meest-gekocht',
    'menstrueren': '/collections/meest-gekocht',
    'menstruel': '/collections/meest-gekocht',
    'cyclus': '/collections/meest-gekocht',
    'periode': '/collections/meest-gekocht',
    
    // Inlegkruisjes
    'inlegkruisjes': '/collections/inlegkruisjes',
    'wasbare inlegkruisjes': '/collections/inlegkruisjes',
    'string inlegkruisjes': '/collections/string-inlegkruisjes',
    'mini inlegkruisjes': '/collections/mini-inlegkruisjes',
    'panty liner': '/collections/inlegkruisjes',
    'panty liners': '/collections/inlegkruisjes',
    'inlegkruisje': '/collections/inlegkruisjes',
    
    // Kraamtijd / Zwanger
    'kraamverband': '/collections/kraamtijd-zwanger',
    'kraamtijd': '/collections/kraamtijd-zwanger',
    'postpartum': '/collections/kraamtijd-zwanger',
    'zwanger': '/collections/kraamtijd-zwanger',
    'bevalling': '/collections/kraamtijd-zwanger',
    'na bevalling': '/collections/kraamtijd-zwanger',
    
    // Incontinentie
    'incontinentie': '/collections/incontinentie',
    'lichte incontinentie': '/collections/lichte-incontinentie',
    'urineverlies': '/collections/lichte-incontinentie',
    
    // Bundles / Start
    'startpakket': '/collections/startpakket',
    'proefpakket': '/collections/startpakket',
    'starterkit': '/collections/startpakket',
    'pakket': '/collections/startpakket',
    'bundel': '/collections/bundel-samenstellen',
    'samenstellen': '/collections/bundel-samenstellen',
    'mix & match': '/collections/bundel-samenstellen',
    
    // Accessoires
    'accessoires': '/collections/accessoires',
    'bewaren': '/collections/opbergen-en-bewaren',
    'wetbag': '/collections/accessoires',
    'waszak': '/collections/accessoires',
    'opbergen': '/collections/opbergen-en-bewaren',
    
    // Pages
    'wasvoorschriften': '/pages/wasvoorschriften',
    'wasadvies': '/pages/wasvoorschriften',
    'wassen': '/pages/wasvoorschriften',
    'gewassen': '/pages/wasvoorschriften',
    'wasmachine': '/pages/wasvoorschriften',
    'onderhoud': '/pages/wasvoorschriften',
    'onderhouden': '/pages/wasvoorschriften',
    'wastips': '/pages/wasvoorschriften',
    'hoe wassen': '/pages/wasvoorschriften',
    
    // FAQ / Contact
    'faq': '/pages/veel-gestelde-vragen',
    'veel gestelde vragen': '/pages/veel-gestelde-vragen',
    'veelgestelde vragen': '/pages/veel-gestelde-vragen',
    'vragen': '/pages/veel-gestelde-vragen',
    'contact': '/pages/contact',
    'klantenservice': '/pages/contact',
    'bereikbaar': '/pages/contact',
    
    // About
    'over lottepads': '/pages/ons-verhaal',
    'ons verhaal': '/pages/ons-verhaal',
    'over ons': '/pages/ons-verhaal',
    'lotte': '/pages/ons-verhaal',
    'visie': '/pages/onze-visie',
    'onze visie': '/pages/onze-visie',
    'bio': '/pages/bio',
    'biologisch': '/pages/bio',
    'organisch': '/pages/bio',
    
    // Attributes
    'duurzaam': '/collections/maandverband',
    'duurzaamheid': '/collections/maandverband',
    'eco': '/collections/maandverband',
    'milieuvriendelijk': '/collections/maandverband',
    'plastic vrij': '/collections/maandverband',
    'chemisch vrij': '/collections/maandverband',
    'zacht': '/collections/maandverband',
    'huidvriendelijk': '/collections/maandverband',
    'gevoelige huid': '/collections/maandverband',
    'huidvriendelijke': '/collections/maandverband',
    'comfortabel': '/collections/maandverband',
    'zacht voor de huid': '/collections/maandverband',
    
    // Flow levels
    'licht bloedverlies': '/collections/licht-bloedverlies',
    'lichte menstruatie': '/collections/licht-bloedverlies',
    'medium bloedverlies': '/collections/medium-maandverband',
    'medium menstruatie': '/collections/medium-maandverband',
    'zwaar bloedverlies': '/collections/zwaar-bloedverlies',
    'zware menstruatie': '/collections/zwaar-bloedverlies',
    'hevig bloedverlies': '/collections/hevig-bloedverlies',
    'hevige menstruatie': '/collections/hevig-bloedverlies',
    
    // General / Popular
    'print': '/collections/nieuw',
    'prints': '/collections/nieuw',
    'kleur': '/collections/nieuw',
    'kleuren': '/collections/nieuw',
    'nieuw': '/collections/nieuw',
    'nieuwste': '/collections/nieuw',
    'sale': '/collections/sale',
    'aanbieding': '/collections/sale',
    'korting': '/collections/sale',
    'afprijs': '/collections/sale',
    
    // Subscription
    'abonnement': '/collections/abonnementen',
    'subscription': '/collections/abonnementen',
    'maandabonnement': '/collections/abonnementen',
    '-jaarabonnement': '/collections/abonnementen',
    'periodiek': '/collections/abonnementen',
    
    // Popular / Best sellers
    'bestseller': '/collections/meest-gekocht',
    'best seller': '/collections/meest-gekocht',
    'meest gekocht': '/collections/meest-gekocht',
    'populair': '/collections/meest-gekocht',
    'trending': '/collections/meest-gekocht'
  };

  // Elements to exclude from linking (already links, forms, etc.)
  const excludeSelectors = [
    'a',
    'script',
    'style',
    'noscript',
    'iframe',
    'select',
    'input',
    'textarea',
    'button',
    '[data-auto-keyword-link="false"]',
    '.no-auto-link',
    '.price-item',
    '.shopify-payment-button__button'
  ];

  // Configuration options
  const config = {
    maxLinksPerPage: 50,           // Maximum total links per page
    maxLinksPerKeyword: 5,         // Maximum links per keyword
    caseSensitive: false,          // Case insensitive matching
    linkClass: 'auto-keyword-link', // CSS class for links
    linkStyle: '', // Style handled by injected CSS
    debug: true                   // Enable console logging
  };

  // Track how many times each keyword has been linked
  const linkedCount = {};
  let totalLinks = 0;

  // Get current page path (without domain) for comparison
  function getCurrentPath() {
    return window.location.pathname.replace(/\/$/, '').toLowerCase();
  }

  // Check if target URL is the current page
  function isCurrentPage(url) {
    if (!url) return false;
    const currentPath = getCurrentPath();
    const targetPath = url.replace(/\/$/, '').toLowerCase();
    return currentPath === targetPath;
  }

  // Initialize on page load
  function init() {
    // Try multiple times to catch Shopify's dynamic content loading
    function tryProcess() {
      const mainContent = document.querySelector('#MainContent, .content-for-layout, main[role="main"]');
      if (mainContent) {
        processPage();
      } else {
        // If no main content found, process entire body anyway
        processPage();
      }
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(tryProcess, 100);
        setTimeout(tryProcess, 1000);
      });
    } else {
      setTimeout(tryProcess, 100);
      setTimeout(tryProcess, 1000);
    }
    
    // Set up observer for dynamic content (AJAX, Shopify sections, etc.)
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(function(mutations) {
        clearTimeout(window.autoKeywordLink.timeout);
        window.autoKeywordLink.timeout = setTimeout(function() {
          const newNodes = mutations.some(function(m) {
            return m.addedNodes.length > 0 && m.addedNodes[0].nodeType === 1;
          });
          if (newNodes && totalLinks < config.maxLinksPerPage) {
            log('Dynamic content detected, reprocessing...');
            processPage();
          }
        }, 1000);
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  // Main function - processes entire page
  function processPage() {
    log('Starting automatic keyword linking...');
    
    const excludeSelector = excludeSelectors.join(', ');
    
    // Create tree walker to find all text nodes
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function(node) {
          // Skip if parent matches exclude selector
          if (node.parentElement && node.parentElement.closest(excludeSelector)) {
            return NodeFilter.FILTER_REJECT;
          }
          // Skip empty or whitespace-only nodes
          if (!node.textContent.trim()) {
            return NodeFilter.FILTER_REJECT;
          }
          // Skip if already inside a link
          if (node.parentElement && node.parentElement.tagName === 'A') {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    // Collect all text nodes
    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      textNodes.push(node);
    }

    log('Found ' + textNodes.length + ' text nodes to process');

    // Process each text node
    textNodes.forEach(function(textNode) {
      if (totalLinks >= config.maxLinksPerPage) return;
      processTextNode(textNode);
    });

    log('Created ' + totalLinks + ' automatic keyword links');
  }

  // Process individual text node
  function processTextNode(textNode) {
    let content = textNode.textContent;
    if (!content.trim()) return;

    // Sort keywords by length (longest first)
    const sortedKeywords = Object.keys(keywordMappings).sort(function(a, b) {
      return b.length - a.length;
    });

    // Build one regex that matches any keyword
    const keywordRegex = new RegExp(
      '\\b(' + sortedKeywords.map(escapeRegExp).join(')|\\b(') + ')\\b',
      config.caseSensitive ? 'g' : 'gi'
    );

    let linkCount = 0;
    let hasLink = false;

    // Replace all keywords in one pass
    const newContent = content.replace(keywordRegex, function(match) {
      if (totalLinks >= config.maxLinksPerPage) return match;
      if (linkCount >= 5) return match; // Max 5 links per text node

      // Find which keyword matched
      let matchedKeyword = null;
      for (let i = 0; i < sortedKeywords.length; i++) {
        if (match.toLowerCase() === sortedKeywords[i].toLowerCase()) {
          matchedKeyword = sortedKeywords[i];
          break;
        }
      }

      if (!matchedKeyword) return match;

      // Skip if target URL is current page
      if (isCurrentPage(keywordMappings[matchedKeyword])) {
        return match;
      }

      // Skip if keyword limit reached
      if ((linkedCount[matchedKeyword] || 0) >= config.maxLinksPerKeyword) {
        return match;
      }

      hasLink = true;
      linkedCount[matchedKeyword] = (linkedCount[matchedKeyword] || 0) + 1;
      totalLinks++;
      linkCount++;

      return '<a href="' + keywordMappings[matchedKeyword] + '" class="' + config.linkClass + '" style="' + config.linkStyle + '">' + match + '</a>';
    });

    // Only replace if we found at least one keyword
    if (hasLink) {
      const span = document.createElement('span');
      span.innerHTML = newContent;

      const fragment = document.createDocumentFragment();
      while (span.firstChild) {
        fragment.appendChild(span.firstChild);
      }

      textNode.parentNode.replaceChild(fragment, textNode);
    }
  }

  // Escape special regex characters
  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // Debug logging
  function log(message) {
    if (config.debug) {
      console.log('[Auto Keyword Link]', message);
    }
  }

  // Expose functions for manual control
  window.autoKeywordLink = {
    reprocess: processPage,
    addKeyword: function(keyword, url) {
      keywordMappings[keyword] = url;
      log('Added keyword: ' + keyword);
    },
    getStats: function() {
      return {
        totalLinks: totalLinks,
        linkedKeywords: linkedCount,
        totalKeywords: Object.keys(keywordMappings).length
      };
    }
  };

  // Start the system
  init();

})();
